import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useApolloClient } from "@apollo/client/react";
import { useProject } from "../../../../contexts/project";
import { GET_SHIPMENT_QUERY } from "src/constants/graphql/queries";

export default function MoreOptions({ shipment }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const location = useLocation();
  const project = useProject();
  const apolloClient = useApolloClient();

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isOnsiteCaptureToWarehouse = project?.settings?.onsite_capture_to_warehouse_storage;
  const isOnsiteManifest = project?.settings?.onsite_manifest;
  const isPreviouslyReceivedAssets = project?.addPreviouslyReceivedAssetsToShipments;
  const isOnsiteInventoryStatus = shipment?.shipmentStatus === 'onsite_inventory';

  const navigateWithParam = (key, value) => {
    const params = new URLSearchParams(location.search);
    params.set(key, value);
    navigate({ search: params.toString() });
    handleClose();
  };

  const showOnsiteInventoryOptions = isOnsiteCaptureToWarehouse && isOnsiteInventoryStatus;
  const showAddInventory = isPreviouslyReceivedAssets;
  const showValidateManifest = isOnsiteManifest && isOnsiteInventoryStatus;

  const handleRefetchShipment = async () => {
    handleClose();
    await apolloClient.refetchQueries({ include: [{ query: GET_SHIPMENT_QUERY, variables: { id: shipment?.id } }] });
  };

  return (
    <>
      <Button
        onClick={handleClick}
        sx={{
          color: "text.primary",
          textTransform: "none",
          fontWeight: 400,
          fontSize: "1rem",
        }}
      >
        More Options
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {showAddInventory && (
          <MenuItem onClick={() => navigateWithParam("receivedItems", "true")}>Receive Returned Item</MenuItem>
        )}
        {showOnsiteInventoryOptions && (
          <MenuItem onClick={() => navigateWithParam("bulkInputLocation", "true")}>Bulk Receive Into Warehouse</MenuItem>
        )}
        {showValidateManifest && (
          <MenuItem onClick={() => navigateWithParam("onsiteManifest", "true")}>Validate Onsite Manifest</MenuItem>
        )}
        {isOnsiteManifest && (
          <MenuItem onClick={handleRefetchShipment}>Refresh Shipment</MenuItem>
        )}
      </Menu>

    </>
  );
}
